import { useLocation } from 'wouter';

/**
 * Auth Hook Adapter
 * Adapts Epic PWA session-based auth to Replit's useAuth() hook pattern
 */

export interface User {
  id: number;
  name?: string;
  email?: string;
}

export function useAuth() {
  const [, setLocation] = useLocation();

  // Epic PWA uses session-based auth, so user is always authenticated
  // if they reach the dashboard (validated by server middleware)
  const user: User = {
    id: 1, // Session-based, no persistent user ID needed
    name: 'Patient Guardian', // Could fetch from session if needed
    email: undefined // Epic doesn't provide email
  };

  const logout = async () => {
    try {
      // Clear session on server
      const response = await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include'
      });

      if (response.ok) {
        // Redirect to login page
        setLocation('/login');
      } else {
        console.error('Logout failed:', await response.text());
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Still redirect to login on error
      setLocation('/login');
    }
  };

  return {
    user,
    logout
  };
}
